import * as Common from '@/tenant/common';

export class Category_BackLog extends Common.ObjectBase{
  constructor(){
    super('Category_BackLog')
  }
  public code: string = '';
}

export class Category_BackLogQuery extends Common.LoadQuery {
  constructor(){
    super('Category_BackLogQuery',Category_BackLog);
    this.sort = 'Code';    
  }

  public code: string = '';
}